import styled from 'styled-components'

const NPS_ORANGE = '#ffa947'
const NPS_ORANGE_HOVER = '#e6983a'
const NPS_TEXT_ON_ORANGE = '#fcfcfd'
const THANKS_GREEN = '#1fba5d'

export const Wrapper = styled.div`
  background: var(--color-white);
  border-radius: var(--border-radius-medium);
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding: 40px;
  width: 100%;
  max-width: 100%;
  position: relative;

  @media (max-width: 768px) {
    padding: 20px 16px 24px;
    gap: 20px;
    border-radius: 16px;
    max-height: calc(100vh - 32px);
    overflow-y: auto;
  }
`

export const CloseRow = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: flex-start;
  width: 100%;
  margin: -8px -8px 0 0;

  @media (max-width: 768px) {
    margin: -4px -4px 0 0;
  }
`

export const CloseButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  padding: 0;
  border: none;
  background: transparent;
  cursor: pointer;
  color: var(--color-dark);
  border-radius: var(--border-radius-default);
  transition:
    background 0.15s,
    color 0.15s;

  &:hover {
    background: var(--color-gray-10);
    color: var(--color-black);
  }
`

export const TitleBlock = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
`

export const Title = styled.h2`
  font-family: inherit;
  font-size: 2.4rem;
  font-weight: 600;
  line-height: 32px;
  color: var(--color-dark);
  margin: 0;

  @media (max-width: 768px) {
    font-size: 2rem;
    line-height: 28px;
    text-align: center;
  }
`

export const Options = styled.form`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
  min-width: 0;

  @media (max-width: 768px) {
    gap: 12px;
  }
`

export const Question = styled.p`
  font-size: 1.6rem;
  font-weight: 400;
  line-height: 24px;
  color: var(--color-dark);
  margin: 0;

  @media (max-width: 768px) {
    font-size: 1.4rem;
    line-height: 22px;
  }
`

export const ScaleRow = styled.div`
  display: flex;
  gap: 8px;
  width: 100%;
  flex-wrap: nowrap;
  overflow-x: auto;
  min-width: 0;

  /* 380px: 11 botões visíveis sem scroll (11*26 + 10*4 = 326px) */
  @media (max-width: 420px) {
    gap: 4px;
  }
`

export const ScaleOption = styled.button<{ $selected?: boolean }>`
  flex: 1 0 0;
  min-width: 28px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 12px 18px;
  border: 1px solid var(--color-gray-50);
  border-radius: var(--border-radius-medium);
  background: transparent;
  cursor: pointer;
  font-size: 1.4rem;
  font-weight: 500;
  line-height: 20px;
  color: var(--color-gray-50);
  transition:
    border-color 0.15s,
    background 0.15s,
    color 0.15s;

  @media (max-width: 768px) {
    padding: 10px 12px;
    min-width: 24px;
    font-size: 1.2rem;
  }

  /* Tela ~380px: todas as notas visíveis sem scroll */
  @media (max-width: 420px) {
    padding: 8px 4px;
    min-width: 26px;
    font-size: 1.2rem;
  }

  &:hover:not(:disabled) {
    border-color: ${NPS_ORANGE};
    background: ${NPS_ORANGE_HOVER};
    color: ${NPS_TEXT_ON_ORANGE};
  }

  ${({ $selected }) =>
    $selected &&
    `
    border-color: ${NPS_ORANGE};
    background: ${NPS_ORANGE};
    color: ${NPS_TEXT_ON_ORANGE};

    &:hover {
      background: ${NPS_ORANGE_HOVER};
      color: ${NPS_TEXT_ON_ORANGE};
    }
  `}
`

export const ScaleLabels = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  font-size: 1.4rem;
  font-weight: 400;
  line-height: 20px;
`

export const LabelLeft = styled.span`
  color: var(--color-error);
`

export const LabelRight = styled.span`
  color: var(--color-success);
`

export const FieldGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  width: 100%;
`

export const FieldLabel = styled.label`
  font-size: 1.4rem;
  font-weight: 500;
  line-height: 20px;
  color: var(--color-gray-80);
  margin: 0;
`

export const TextareaWrap = styled.div`
  .textarea {
    margin: 0;
  }

  .textarea textarea {
    min-height: 80px;
    font-size: 1.6rem;
    line-height: 24px;
    color: var(--color-dark);
  }
`

export const Buttons = styled.div`
  display: flex;
  gap: 16px;
  width: 100%;

  button {
    flex: 1 1 0;
    min-width: 0;
  }

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 12px;

    button {
      width: 100%;
    }
  }
`

export const SurveyOutlineButton = styled.button`
  flex: 1 1 0;
  min-width: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px 18px;
  border: 1px solid ${NPS_ORANGE};
  border-radius: var(--border-radius-medium);
  background: transparent;
  color: ${NPS_ORANGE};
  font-size: 1.6rem;
  font-weight: 500;
  line-height: 24px;
  cursor: pointer;
  transition:
    background 0.15s,
    color 0.15s,
    border-color 0.15s;

  &:hover {
    background: ${NPS_ORANGE};
    color: ${NPS_TEXT_ON_ORANGE};
  }
`

export const SurveyPrimaryButton = styled.button<{ $disabled?: boolean }>`
  flex: 1 1 0;
  min-width: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px 18px;
  border: 1px solid ${NPS_ORANGE};
  border-radius: var(--border-radius-medium);
  background: ${NPS_ORANGE};
  color: ${NPS_TEXT_ON_ORANGE};
  font-size: 1.6rem;
  font-weight: 500;
  line-height: 24px;
  cursor: pointer;
  box-shadow: 0 1px 2px rgba(12, 17, 29, 0.1);
  transition:
    background 0.15s,
    filter 0.15s;

  &:hover:not(:disabled) {
    filter: brightness(0.95);
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`

/* Thanks screen (after submit) */
export const ThanksWrapper = styled.div`
  background: var(--color-white);
  border-radius: 20px;
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding: 40px;
  width: 100%;
  max-width: 100%;
  position: relative;

  @media (max-width: 768px) {
    padding: 20px 16px 24px;
    gap: 20px;
    border-radius: 16px;
    max-height: calc(100vh - 32px);
    overflow-y: auto;
  }
`

export const ThanksTitleBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
  text-align: center;
`

export const ThanksTitle = styled.h2`
  font-family: inherit;
  font-size: 2.4rem;
  font-weight: 600;
  line-height: 32px;
  color: var(--color-dark);
  margin: 0;

  @media (max-width: 768px) {
    font-size: 2rem;
    line-height: 28px;
  }
`

export const ThanksSubtitle = styled.p`
  font-size: 1.6rem;
  font-weight: 400;
  line-height: 24px;
  color: var(--color-gray-50);
  margin: 0;

  @media (max-width: 768px) {
    font-size: 1.4rem;
    line-height: 22px;
  }
`

export const ThanksButtons = styled.div`
  display: flex;
  gap: 24px;
  width: 100%;
`

export const ThanksCloseButton = styled.button`
  flex: 1 1 0;
  min-width: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px 18px;
  border: 1px solid ${THANKS_GREEN};
  border-radius: var(--border-radius-medium);
  background: ${THANKS_GREEN};
  color: ${NPS_TEXT_ON_ORANGE};
  font-size: 1.6rem;
  font-weight: 500;
  line-height: 24px;
  cursor: pointer;
  box-shadow: 0 1px 2px rgba(12, 17, 29, 0.1);
  transition: filter 0.15s;

  &:hover {
    filter: brightness(0.95);
  }

  @media (max-width: 768px) {
    width: 100%;
    padding: 12px 18px;
  }
`
